import React, { useCallback } from 'react';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { useIsEmbeddedMobile } from '../../../../_hooks/useIsEmbeddedMobile';
import { useRouteParams } from '../../../hooks/useRouteParams';
import { TabSlug } from '../../../types';
import { Wrapper } from './PositionsLink.styles';

interface Props extends WrapperProps {
  name: string;
}

export const PositionsLink = ({ name, ...rest }: Props) => {
  const { accountId, clientId, groupId, isApex, tabSlug } = useRouteParams();

  const onClick = useCallback(() => {
    ADV.util.Router.go2('AccountPerformanceReporting', {
      clientId,
      groupId,
      accountId,
      tabSlug: TabSlug.Allocation,
      allocationType: encodeURIComponent(name),
      isApex,
    });
  }, [accountId, clientId, groupId, isApex, name]);

  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (tabSlug === 'allocation') {
    return null;
  }

  return (
    <Wrapper {...rest} isEmbeddedMobile={isEmbeddedMobile}>
      <Button
        variant="link"
        variantColor="neutral"
        onClick={onClick}
        rightIcon="fas fa-chevron-right"
      >
        Allocation Details
      </Button>
    </Wrapper>
  );
};
